<template>
  <div>
    <view-table
        ref="viewTable"
        :limits="limits"
        :columns-property="columnsProperty"
        :filter="filter"
        method="postJson"
        module="basic"
        :auth-index="129"
        :auth-column-keywords="['生产订单', '入库数量', '未入库数量', '工单数量', 'MRP控制者']"
        url="sapSalesOrderDetails"
        @reset="resetHandle"
        @select="selectHandle">
      <template slot="adSearch">
        <div class="vm-search">
          <el-form :inline="true" :model="filter" label-width="65px" @keyup.enter.native="loadData(1)">
            <el-form-item label="订单编号">
              <el-input v-model.trim="filter.salesOrderNo" placeholder="请输入订单编号" clearable/>
            </el-form-item>
            <el-form-item label="订单类型">
              <el-select
                  v-model="filter.salesOrderCategory"
                  placeholder="请选择订单类型"
                  :multiple="true"
                  clearable>
                <el-option v-for="item in property" :key="item.no" :value="item.no" :label="item.name"/>
              </el-select>
            </el-form-item>
            <el-form-item label="客户名称">
              <el-input v-model.trim="filter.customerName" placeholder="请输入客户名称" clearable/>
            </el-form-item>
            <el-form-item label="厂家型号">
              <el-input v-model.trim="filter.manufacturerModel" placeholder="请输入规格型号" clearable/>
            </el-form-item>
            <el-form-item label="计划交期">
              <el-date-picker
                  v-model="deliveryDateRange"
                  style="width: 372px; margin-right: 10px;"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始时间"
                  end-placeholder="结束时间"
                  value-format="yyyy-MM-dd"
                  @change="dateRangeChange('deliveryDateRange', 'deliveryBeginDate', 'deliveryEndDate')"/>
              <el-checkbox v-model="filter.nullDeliveryDate">为空</el-checkbox>
            </el-form-item>
            <el-form-item label="销售交期">
              <el-date-picker
                  v-model="salesDeliveryDateRange"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始时间"
                  end-placeholder="结束时间"
                  value-format="yyyy-MM-dd"
                  @change="dateRangeChange('salesDeliveryDateRange', 'salesDeliveryBeginDate', 'salesDeliveryEndDate')"/>
            </el-form-item>
            <el-form-item label="创建日期">
              <el-date-picker
                  v-model="createDateRange"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始时间"
                  end-placeholder="结束时间"
                  value-format="yyyy-MM-dd"
                  @change="dateRangeChange('createDateRange', 'createBeginDate', 'createEndDate')"/>
            </el-form-item>
            <el-form-item label="前续单据">
              <el-input v-model.trim="filter.sourceOrder" placeholder="请输入续单据" clearable/>
            </el-form-item>
            <el-form-item label="合同编号">
              <el-input v-model.trim="filter.clientContractNo" placeholder="请输入合同编号" clearable/>
            </el-form-item>
            <el-form-item label="物料编号">
              <el-input v-model.trim="filter.materialNo" placeholder="请输入物料编号" clearable/>
            </el-form-item>
            <el-form-item label="物料名称">
              <el-input v-model.trim="filter.materialName" placeholder="请输入物料名称" clearable/>
            </el-form-item>
            <el-form-item label="规格型号">
              <el-input v-model.trim="filter.specification" placeholder="请输入规格型号" clearable/>
            </el-form-item>
            <el-form-item label="制单人">
              <el-select
                  v-model="filter.creatorNameList"
                  :multiple="true"
                  filterable
                  clearable
                  placeholder="请选择制单人">
                <el-option
                    v-for="item in creatorNameOptions"
                    :key="item"
                    :label="item"
                    :value="item"/>
              </el-select>
            </el-form-item>
            <el-form-item label="销售员">
              <el-select
                  v-model="filter.salePersonNameList"
                  :multiple="true"
                  filterable
                  clearable
                  placeholder="请选择销售员">
                <el-option
                    v-for="item in salePersonNameOptions"
                    :key="item"
                    :label="item"
                    :value="item"/>
              </el-select>
            </el-form-item>
            <el-form-item label="商务专员">
              <el-select
                  v-model="filter.businessSpecialistNameList"
                  :multiple="true"
                  filterable
                  clearable
                  placeholder="请选择商务专员">
                <el-option
                    v-for="item in businessSpecialistNameOptions"
                    :key="item"
                    :label="item"
                    :value="item"/>
              </el-select>
            </el-form-item>
            <el-form-item label="发货状态">
              <el-select v-model="filter.deliverStatus" clearable placeholder="请选择状态">
                <el-option label="已发" :value="1"/>
                <el-option label="未发" :value="2"/>
              </el-select>
            </el-form-item>
            <el-form-item label="撤销状态">
              <el-select v-model="filter.revokeStatus" clearable placeholder="请选择撤销状态">
                <el-option label="未撤销" :value="false"/>
                <el-option label="已撤销" :value="true"/>
              </el-select>
            </el-form-item>
            <!--            <el-form-item label="备注">-->
            <!--              <el-input v-model.trim="filter.detailNote" placeholder="请输入备注" clearable/>-->
            <!--            </el-form-item>-->
          </el-form>
        </div>
      </template>
      <template slot="actionBtn"/>
      <template slot="otherBtn">
        <el-button v-if="limits.borrowAuth" type="primary" :disabled="selection.length===0" @click="getClientContractByDetail">
          借出转销售合同
        </el-button>
        <el-button v-if="limits.batchJishouAuth" type="primary" :disabled="selection.length===0" @click="getZJE">
          批量寄售冲账
        </el-button>
      </template>
    </view-table>
    <client-contract-edit ref="clientContractEdit"/>
    <sales-order-ji-shou-edit ref="salesOrderJiShouEdit"/>
    <dispatch-detail ref="dispatchDetail" @save-success="loadData"/>
  </div>
</template>

<script>
  import loginUtil from "@/util/loginUtil";
  import ViewTable from "@/components/ViewTable";
  import ClientContractEdit from "@/views/SalesManage/SalesClientContract/ClienContractEdit";
  import SalesOrderJiShouEdit from "@/views/SalesManage/SalesOrder/SalesOrderJiShouEdit";
  import DispatchDetail from "@/views/ProductionManagement/ProductionOrder/DispatchDetail";

  export default {
    name: "SalesOrderDetailList",
    components: {ClientContractEdit, ViewTable, SalesOrderJiShouEdit,DispatchDetail},
    data() {
      return {
        limits: {
          borrowAuth: this.$auth(322),
          batchJishouAuth: this.$auth(331),
        },
        property: [],
        filter: {
          salesOrderNo: "",
          deliveryBeginDate: "",
          deliveryEndDate: "",
          orderBeginDate: "",
          orderEndDate: "",
          createBeginDate: "",
          createEndDate: "",
          submitBeginDate: "",
          submitEndDate: "",
          salesDeliveryBeginDate: "",
          salesDeliveryEndDate: "",
          customerName: "",
          creator: "",
          salesOrderCategory: [],
          customerContractNo: "",
          projectName: "",
          billNo: "",
          status: "",
          deliverStatus: "",
          revokeStatus: false,
          materialNo: "",
          materialName: "",
          specification: "",
          detailNote: "",
          sourceOrder:"",
          clientContractNo:"",
          nullDeliveryDate:"",
        },
        columnsProperty: [
          {
            key: "salesOrderNo",
            width: 130,
            align: "center",
          },
          {
            key: "salesOrderCategoryName",
            width: 160,
            align: "center",
          },
          {
            key: "rowIndex",
            width: 150,
            align: "center",
          },
          {
            key: "rowIndex",
            width: 100,
          },
          {
            key: "materialNo",
            width: 200,
          },
          {
            key: "materialName",
            width: 260,
          },
          {
            key: "price",
            width: 100,
          },
          {
            key: "quantity",
            width: 100,
          },
          {
            key: "unit",
            width: 100,
          },
          {
            key: "deliveryDate",
            width: 160,
          },
          {
            key: "salesDeliveryDate",
            width: 160,
          },
          {
            key: "submitTime",
            title: "提交时间",
            width: 160,
            align: "center",
          },
          {
            key: "specification",
            width: 260,
          },
          {
            key: "manufacturerModel",
            width: 260,
          },
          {
            key: "customerNo",
            width: 100,
          },
          {
            key: "customerName",
            width: 260,
          },
          {
            key: "salesOrderCategoryName",
            width: 260,
          },
          {
            key: "remainQuantity",
            width: 100,
          },
          {
            key: "invoiceQty",
            width: 100,
          },
          {
            key: "totalNetPrice",
            width: 100,
          },
          {
            key: "totalTaxPrice",
            width: 100,
          },
          {
            key: "sapstatus",
            width: 100,
          },
          {
            key: "orders",
            width: 150,
            align: "center",
            render: (h, params) => {
              const list = params.row.orders.split(",");
              const spanNodes = list.map(item => {
                // h(标签, 属性, 子元素/内容)
                return h(
                  "span",
                  {
                    // 样式：鼠标手型、间距、颜色（可自定义）
                    style: {
                      margin: "0 6px",
                      color: "#409eff",
                      cursor: "pointer",
                    },
                    // 点击事件：跳转到详情页
                    on: {
                      click: () => {
                        this.$refs.dispatchDetail.openByNo(item);
                      },
                    },
                  },
                  item // span 显示的内容
                );
              });
              return h("div", spanNodes);
            },
          },
        ],
        options: [],
        submitDateRange: [],
        salesDeliveryDateRange: [],
        createDateRange: [],
        deliveryDateRange: [],
        importCustomerId: "1963",
        YWTimportLoading: false,
        importLoading: false,
        importCustomerLoading: false,
        uploadUrl: window.config.basicServerUrl + "sd/so/importContractFile",
        uploadHeaders: {Authorization: loginUtil.getToken()},
        disabled: false,
        importPdfLoading: false,
        uploadLoading: false,
        selection: [],
        submitLoading: false,
        creatorNameOptions: [],
        salePersonNameOptions: [],
        businessSpecialistNameOptions: [],
      };
    },

    watch: {
      "filter.deliveryBeginDate": {
        handler(newVal) {
          if (newVal) {
            this.deliveryDateRange = [];
            this.deliveryDateRange.push(this.filter.deliveryBeginDate);
            this.deliveryDateRange.push(this.filter.deliveryEndDate);
          }
        },
      },
      "filter.orderBeginDate": {
        handler(newVal) {
          if (newVal) {
            this.createDateRange = [];
            this.createDateRange.push(this.filter.orderBeginDate);
            this.createDateRange.push(this.filter.orderEndDate);
          }
        },
      },
      "filter.submitBeginDate": {
        handler(newVal) {
          if (newVal) {
            this.submitDateRange = [];
            this.submitDateRange.push(this.filter.submitBeginDate);
            this.submitDateRange.push(this.filter.submitEndDate);
          }
        },
      },
    },

    // created() {
    //   this.getAreaOptions();
    // },
    mounted() {
      this.getSalesOrderCategory();
      this.getDistinctOptions();
    },

    methods: {
      loadData(pageNum) {
        this.$refs.viewTable.loadData(pageNum);
      },

      getSalesOrderCategory() {
        this.$http.get("basic", "sapSalesOrders/getSalesOrderCategory").then((res) => {
          if (res.success) {
            this.property = res.data;
          }
        });
      },

      getDistinctOptions() {
        this.$http.get("basic", "sapSalesOrderDetails/getDistinctOptions").then((res) => {
          if (res.success) {
            this.creatorNameOptions = res.data.creatorNames || [];
            this.salePersonNameOptions = res.data.salePersonNames || [];
            this.businessSpecialistNameOptions = res.data.businessSpecialistNames || [];
          }
        });
      },

      dateRangeChange(timeRange, timeStart, timeEnd) {
        if (this[timeRange]) {
          this.filter[timeStart] = this[timeRange][0];
          this.filter[timeEnd] = this[timeRange][1];
        } else {
          this.filter[timeStart] = "";
          this.filter[timeEnd] = "";
        }
      },


      selectHandle(selection) {
        this.selection = selection;
      },

      resetHandle(filter) {
        this.filter = Object.assign(this.filter, filter);
      },

      //未提交、退单可以编辑删除
      otherAuth() {
        return true;
      },

      getClientContractByDetail() {
        if (this.selection.length === 0) {
          this.$message.error("请先选择数据");
        } else if (this.selection.filter(item => item.property !== "ZKB").length) {
          this.$message.error("仅能勾选借出订单!");
        } else if (this.selection.filter(item => item.remainQuantity <= 0).length) {
          this.$message.error("存在剩余数量不为0的行项!");
        } else {
          let ids = [];
          this.selection.forEach(item => ids.push(item.pkId));
          this.$http.post("basic", "sapSalesOrderDetails/getClientContractByDetail", ids)
            .then((resp) => {
              if (resp.success) {
                console.log(resp);
                this.$refs.clientContractEdit.open(null, false, resp.data);
              }
            });
        }

      },

      getZJE() {
        if (this.selection.length === 0) {
          this.$message.error("请先选择数据");
        } else if (this.selection.filter(item => item.property !== "ZJB").length) {
          this.$message.error("仅能勾选寄售发出订单!");
        } else if (this.selection.filter(item => item.remainQuantity <= 0).length) {
          this.$message.error("存在剩余数量不为0的行项!");
        } else {
          this.$refs.salesOrderJiShouEdit.open(this.selection);
        }

      },
    },
  };
</script>

